export default "https://cdn-static.gokick.com/assets/5d59d840aa8978759fe32f9d0593dfb9088da5d0/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";